import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';
import { getAllCustomerLinks } from './getAllCustomerLinks';

export const ADD_CUSTOMER_LINK_REQUEST = 'ADD_CUSTOMER_LINK_REQUEST';
export const ADD_CUSTOMER_LINK_SUCCESS = 'ADD_CUSTOMER_LINK_SUCCESS';
export const ADD_CUSTOMER_LINK_FAILURE = 'ADD_CUSTOMER_LINK_FAILURE';

function request() {
  return {
    type: ADD_CUSTOMER_LINK_REQUEST
  };
}

function receive() {
  return {
    type: ADD_CUSTOMER_LINK_SUCCESS,
  };
}

function fail() {
  return {
    type: ADD_CUSTOMER_LINK_FAILURE,
  };
}

export function addCustomerLink(fromCustomerId, toCustomerId, relationshipType, effectiveFrom, effectiveTo, onSuccess) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .addCustomerLink(fromCustomerId, toCustomerId, relationshipType, effectiveFrom, effectiveTo)
      .then((response) => {
        dispatch(receive());
        toastr.success('Success', 'Customer Link added successfully');
        dispatch(getAllCustomerLinks(fromCustomerId));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, fail, true));
        }
      });
    return promise();
  };
}
